import angular from 'angular';
import '../resources/display';
import '../factories/socket.io';
import '../services/socket';
import { localStorage as ls } from '../utils';

const module = angular.module('whyline.sockets.display', [
    'whyline.factories.socket',
    'whyline.services.socket',
    'whyline.resources.display'
]);

const DisplaySocket = (Display, $rootScope, SOCKET_URL) => {
    'ngInject';
    let socket;
    let newSocket;
    const reconnectInterval = 5000;
    const heartbeatInterval = 60000;
    const autoReconnectInterval = 3600000;
    let heartbeatTimer;
    let autoReconnectTimer;
    let reconnectTimer;
    let isReconnecting = false;

    const sendHeartbeat = () => {
        if (socket && socket.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify({ type: 'heartbeat', timestamp: Date.now() }));
        }
    };

    const initializeWebSocket = (WS_URL) => {
        clearTimeout(reconnectTimer);

        newSocket = new WebSocket(WS_URL);

        let newHeartbeatTimer;
        let newAutoReconnectTimer;

        newSocket.addEventListener('open', () => {
            console.log('Nueva conexión WebSocket abierta');
            $rootScope.$emit('socket:display-connected');

            isReconnecting = false;

            clearInterval(newHeartbeatTimer);
            newHeartbeatTimer = setInterval(() => sendHeartbeat(newSocket), heartbeatInterval);

            clearTimeout(newAutoReconnectTimer);
            newAutoReconnectTimer = setTimeout(() => {
                console.log('Reconexión automática');
                reconnectSocket(WS_URL);
            }, autoReconnectInterval);

            const oldSocket = socket;
            socket = newSocket;

            clearInterval(heartbeatTimer);
            clearTimeout(autoReconnectTimer);

            heartbeatTimer = newHeartbeatTimer;
            autoReconnectTimer = newAutoReconnectTimer;

            if (oldSocket && oldSocket !== newSocket) {
                console.log('Cerrando conexión WebSocket anterior');
                oldSocket.onopen = oldSocket.onmessage = oldSocket.onerror = oldSocket.onclose = null;
                oldSocket.close();
            }

            newSocket = null;
        });
        
        newSocket.addEventListener('message', (event) => {
            try {
                const data = JSON.parse(event.data);
                handleIncomingMessage(data);
            } catch (error) {
                console.error('Error al parsear el mensaje:', error);
            }
        });

        newSocket.addEventListener('error', (error) => {
            console.error('Error en WebSocket:', error);
            if (newSocket) {
                newSocket.close();
            }
        });

        newSocket.addEventListener('close', () => {
            console.log('Conexión WebSocket cerrada');
            clearInterval(newHeartbeatTimer);
            clearTimeout(newAutoReconnectTimer);
            if (!isReconnecting && socket === newSocket) {
                isReconnecting = true;
                reconnectSocket(WS_URL);
            }
        });
    };

    const reconnectSocket = (WS_URL) => {
        if (reconnectTimer) {
            clearTimeout(reconnectTimer);
        }

        reconnectTimer = setTimeout(() => {
            console.log('Intentando reconectar WebSocket...');
            initializeWebSocket(WS_URL);
        }, reconnectInterval);
    };

    const handleIncomingMessage = (data) => {
        switch (data.type) {
            case 'display:created':
                Display.UpdateCache(data.display._id, data.display);
                break;
            case 'display:updated':
                Display.UpdateCache(data.display._id, data.display);
                break;
            case 'display:deleted':
                Display.RemoveFromCache(data.display._id, data.display._type);
                break;
            case 'display:call-subscription':
                $rootScope.$emit('display:call-subscription', data);
                break;
            case 'display:recall-subscription':
                console.log(data);
                $rootScope.$emit('display:recall-subscription', data);
                break;
            case 'display:identify':
                $rootScope.$emit('display:identify', data);
                break;
            case 'display:minmax':
                $rootScope.$emit('display:minmax', data);
                break;
            case 'display:refresh':
                $rootScope.$emit('display:refresh', data);
                break;
            case 'external-display:updated':
                $rootScope.$emit('external-display:updated', data);
                break;
            case 'external-display:created':
                $rootScope.$emit('external-display:created', data);
                break;
            case 'external-display:deleted':
                $rootScope.$emit('external-display:deleted', data);
                break;
            default:
                console.log('Mensaje no manejado:', data);
        }
    };

    const disconnectSocket = () => {
        if (socket) {
            socket.close();
            socket = null;
        }
        clearInterval(heartbeatTimer);
        clearTimeout(autoReconnectTimer);
        clearTimeout(reconnectTimer);
        isReconnecting = false;
    };

    $rootScope.$on('display:disconnect', () => {
        disconnectSocket();
    });

    $rootScope.$on("display-tv:open-websocket-connection", (_event, data) => {
        const token = ls.get('token');
        const WS_URL = `${SOCKET_URL}?auth_key=${token}&entity_id=${data.displayId}&type=DISPLAY`;
        initializeWebSocket(WS_URL);
    });

    $rootScope.$on("display-tv:close-websocket-connection", (_event, _data) => {
        disconnectSocket();
    });
};

module.factory('DisplaySocket', (Display, $rootScope, SOCKET_URL) => new DisplaySocket(Display, $rootScope, SOCKET_URL));

export default module;